module.exports = __webpack_public_path__ + "static/media/Nurse_treating_patients_online_through_Curoflow_telemedicine_platform.94703328.webp";